/**
 * 창조신 김마고 - 게임 상태 타입 정의
 * 순수 데이터만 포함 - window, document, PIXI 절대 금지
 */

import { BASE_ELEMENTS, createBaseElementMap, type ElementCategory, type ElementInfo } from './content.js';

export const MAX_ENERGY = 20;
export const ENERGY_RECHARGE_INTERVAL_MS = 10 * 60 * 1000; // 10분

export type Screen = 'title' | 'opening' | 'nickname' | 'tutorial' | 'main';
export type MainTab = 'encyclopedia' | 'rankings' | 'profile';
export type SortMode = 'recent' | 'name' | 'tier';
export type CategoryFilter = ElementCategory | 'all';

export interface PendingCombine {
  a: string;
  b: string;
  remaining: number;
  status: 'animating' | 'waiting-server';
}

export interface CombinationRecord {
  result: string;
  tier: number;
  category: ElementCategory;
  firstDiscoverer: string;
  discoveredAt: string;
  totalDiscoveries: number;
}

export interface ResultPopupState {
  kind: 'discovered' | 'first-discovery' | 'already-owned' | 'milestone';
  result: ElementInfo;
  firstDiscoverer: string;
  isNew: boolean;
  isFirstEver: boolean;
  milestoneDescription?: string;
}

export interface GameState {
  isRunning: boolean;
  playTime: number;
  screen: Screen;
  hasSeenOpening: boolean;
  openingPage: number;
  nickname: string;
  nicknameDraft: string;
  authToken: string | null;
  tutorialCompleted: boolean;
  activeTab: MainTab;
  searchQuery: string;
  sortMode: SortMode;
  categoryFilter: CategoryFilter;
  slotA: string | null;
  slotB: string | null;
  pendingCombine: PendingCombine | null;
  inventory: string[];
  elements: Record<string, ElementInfo>;
  comboCache: Record<string, CombinationRecord>;
  firstDiscoveries: string[];
  resultPopup: ResultPopupState | null;
  energy: number;
  lastEnergyRechargeAt: number;
}

export function createInitialState(): GameState {
  return {
    isRunning: true,
    playTime: 0,
    screen: 'title',
    hasSeenOpening: false,
    openingPage: 0,
    nickname: '',
    nicknameDraft: '',
    authToken: null,
    tutorialCompleted: false,
    activeTab: 'encyclopedia',
    searchQuery: '',
    sortMode: 'recent',
    categoryFilter: 'all',
    slotA: null,
    slotB: null,
    pendingCombine: null,
    inventory: BASE_ELEMENTS.map((element) => element.name),
    elements: createBaseElementMap(),
    comboCache: {},
    firstDiscoveries: [],
    resultPopup: null,
    energy: MAX_ENERGY,
    lastEnergyRechargeAt: Date.now()
  };
}
